import { Box, Grid } from '@mui/material'
import { TitleWithCount } from 'components/core-ui/TitleWithCount'
import s from './ImagesList.modules.scss'
import { DeleteIconDarkBackground, PDFIconGreyBackground } from 'icons'

export interface ImagesListProps {
  images: File[]
  deleteImage: (image: File) => void
}

const ImagesList = (props: ImagesListProps) => {
  const { images, deleteImage } = props

  return (
    <Box>
      <TitleWithCount title="imagini au fost adaugate" counter={images.length} showCounterFirst />
      <Box className={s.imagesList}>
        <Grid container spacing={4}>
          {images.map((image: File) => (
            <Grid key={`${image.lastModified}-${image.size}`} item xs={4} md={3}>
              <Box className={s.imageContainer}>
                {image.type === 'application/pdf' ? (
                  <PDFIconGreyBackground />
                ) : (
                  <img src={URL.createObjectURL(image)} />
                )}
                <Box className={s.deleteContainer} onClick={() => deleteImage(image)}>
                  <DeleteIconDarkBackground />
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  )
}

export default ImagesList
